function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M107.005 14.0698H13.2549C8.07721 14.0698 3.87988 18.2672 3.87988 23.4448V87.1948C3.87988 92.3725 8.07721 96.5698 13.2549 96.5698H107.005C112.183 96.5698 116.38 92.3725 116.38 87.1948V23.4448C116.38 18.2672 112.183 14.0698 107.005 14.0698Z",
  fill: "#686868"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3799 21.5698H108.88V81.5698H11.3799V21.5698Z",
  fill: "#BCE4F8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3799 21.5698V74.0698H93.8799C95.869 74.0698 97.7767 73.2796 99.1832 71.8731C100.59 70.4666 101.38 68.5589 101.38 66.5698V21.5698H11.3799Z",
  fill: "#E4F5FD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6299 4.69482H97.6299V53.4448H22.6299V4.69482Z",
  fill: "#F3A845"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6299 4.69482L60.1299 34.6948L97.6299 4.69482H22.6299Z",
  fill: "#EECC61"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M60.1299 34.6948L53.0986 29.0698L22.6299 53.4448H97.6299L67.1611 29.0698L60.1299 34.6948Z",
  fill: "#F1D681"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M90.1299 32.8198C89.6326 32.8198 89.1557 32.6223 88.8041 32.2707C88.4524 31.919 88.2549 31.4421 88.2549 30.9448V21.5698C88.2549 21.0725 88.4524 20.5956 88.8041 20.244C89.1557 19.8924 89.6326 19.6948 90.1299 19.6948C90.6272 19.6948 91.1041 19.8924 91.4557 20.244C91.8073 20.5956 92.0049 21.0725 92.0049 21.5698V30.9448C92.0049 31.4421 91.8073 31.919 91.4557 32.2707C91.1041 32.6223 90.6272 32.8198 90.1299 32.8198Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M90.1299 40.3198C89.6326 40.3198 89.1557 40.1223 88.8041 39.7707C88.4524 39.419 88.2549 38.9421 88.2549 38.4448V36.5698C88.2549 36.0725 88.4524 35.5956 88.8041 35.244C89.1557 34.8924 89.6326 34.6948 90.1299 34.6948C90.6272 34.6948 91.1041 34.8924 91.4557 35.244C91.8073 35.5956 92.0049 36.0725 92.0049 36.5698V38.4448C92.0049 38.9421 91.8073 39.419 91.4557 39.7707C91.1041 40.1223 90.6272 40.3198 90.1299 40.3198Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M32.0049 109.695H88.2549V117.195H32.0049V109.695Z",
  fill: "#686868"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M73.2549 96.5698H47.0049L39.5049 109.695H80.7549L73.2549 96.5698Z",
  fill: "#939393"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M32.0049 109.695V113.445H78.8799C80.0398 113.443 81.1705 113.081 82.1161 112.409C83.0618 111.738 83.7758 110.789 84.1599 109.695H32.0049Z",
  fill: "#868686"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M107.005 12.1948H99.5049V4.69482C99.5049 4.19754 99.3073 3.72063 98.9557 3.369C98.6041 3.01737 98.1272 2.81982 97.6299 2.81982H22.6299C22.1326 2.81982 21.6557 3.01737 21.3041 3.369C20.9524 3.72063 20.7549 4.19754 20.7549 4.69482V12.1948H13.2549C10.2721 12.1978 7.41236 13.384 5.30322 15.4932C3.19408 17.6023 2.00786 20.4621 2.00488 23.4448V87.1948C2.00786 90.1776 3.19408 93.0373 5.30322 95.1465C7.41236 97.2556 10.2721 98.4418 13.2549 98.4448H43.7743L38.4174 107.82H32.0049C31.5076 107.82 31.0307 108.017 30.6791 108.369C30.3274 108.721 30.1299 109.198 30.1299 109.695V117.195C30.1299 117.692 30.3274 118.169 30.6791 118.521C31.0307 118.872 31.5076 119.07 32.0049 119.07H88.2549C88.7522 119.07 89.2291 118.872 89.5807 118.521C89.9323 118.169 90.1299 117.692 90.1299 117.195V109.695C90.1299 109.198 89.9323 108.721 89.5807 108.369C89.2291 108.017 88.7522 107.82 88.2549 107.82H81.8424L76.4855 98.4448H107.005C109.988 98.4418 112.847 97.2556 114.957 95.1465C117.066 93.0373 118.252 90.1776 118.255 87.1948V23.4448C118.252 20.4621 117.066 17.6023 114.957 15.4932C112.847 13.384 109.988 12.1978 107.005 12.1948ZM27.9755 51.5698L53.1005 31.4717L58.9599 36.1592C59.2924 36.4255 59.7057 36.5705 60.1318 36.5705C60.5578 36.5705 60.9711 36.4255 61.3036 36.1592L67.163 31.4717L92.2843 51.5698H27.9755ZM70.163 29.0698L95.7549 8.5967V49.5429L70.163 29.0698ZM60.1299 32.2948L27.9755 6.56982H92.288L60.1299 32.2948ZM50.0968 29.0698L24.5049 49.5429V8.5967L50.0968 29.0698ZM86.3799 115.32H33.8799V111.57H86.3799V115.32ZM77.5243 107.82H42.7355L48.0924 98.4448H72.1674L77.5243 107.82ZM114.505 87.1948C114.505 89.1839 113.715 91.0916 112.308 92.4981C110.902 93.9046 108.994 94.6948 107.005 94.6948H13.2549C11.2658 94.6948 9.3581 93.9046 7.95158 92.4981C6.54506 91.0916 5.75488 89.1839 5.75488 87.1948V23.4448C5.75488 21.4557 6.54506 19.548 7.95158 18.1415C9.3581 16.735 11.2658 15.9448 13.2549 15.9448H20.7549V19.6948H11.3799C10.8826 19.6948 10.4057 19.8924 10.0541 20.244C9.70243 20.5956 9.50488 21.0725 9.50488 21.5698V81.5698C9.50488 82.0671 9.70243 82.544 10.0541 82.8957C10.4057 83.2473 10.8826 83.4448 11.3799 83.4448H47.0049V79.6948H13.2549V23.4448H20.7549V53.4448C20.7549 53.9421 20.9524 54.419 21.3041 54.7707C21.6557 55.1223 22.1326 55.3198 22.6299 55.3198H58.2549V72.1948H62.0049V55.3198H97.6299C98.1272 55.3198 98.6041 55.1223 98.9557 54.7707C99.3073 54.419 99.5049 53.9421 99.5049 53.4448V23.4448H107.005V79.6948H73.2549V83.4448H108.88C109.377 83.4448 109.854 83.2473 110.206 82.8957C110.557 82.544 110.755 82.0671 110.755 81.5698V21.5698C110.755 21.0725 110.557 20.5956 110.206 20.244C109.854 19.8924 109.377 19.6948 108.88 19.6948H99.5049V15.9448H107.005C108.994 15.9448 110.902 16.735 112.308 18.1415C113.715 19.548 114.505 21.4557 114.505 23.4448V87.1948Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M103.255 87.1948H107.005V90.9448H103.255V87.1948Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M95.7549 87.1948H99.5049V90.9448H95.7549V87.1948Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M50.7549 59.0698H54.5049V87.1948H50.7549V59.0698Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M65.7549 59.0698H69.5049V87.1948H65.7549V59.0698Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M58.2549 75.9448H62.0049V79.6948H58.2549V75.9448Z",
  fill: "black"
});

function SvgInternalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalIcon);
export default __webpack_public_path__ + "static/media/internal-icon.431d95eb.svg";
export { ForwardRef as ReactComponent };